export function isMultiple(
  possibleMultiple: number,
  reference: number,
  exponent = 0,
) {
  return (
    Math.round(10 ** (exponent || 0) * possibleMultiple) %
      Math.round(10 ** (exponent || 0) * reference) ===
    0
  );
}

export function roundIfNecessary(value = 0) {
  return Math.round(value * 100) / 100;
}

export function toNumber(value?: string | number | null) {
  if (value === undefined || value === null || value === '') return undefined;

  const parsed = Number(String(value).replace(',', '.'));

  return Number.isNaN(parsed) ? undefined : parsed;
}
